import dayjs from 'dayjs';

const MONTHS_COUNT = 5;

export const getLastMonths = () => {
  return Array.from({ length: MONTHS_COUNT }, (_, i) => dayjs().subtract(i + 1, 'month'));
};
